<template>
  <span>
    <span v-if="!puidPublished" class="m-10">
      <el-tooltip class="item" effect="dark" :content="$t('products.publish')" placement="top">
       <el-button type="text" :disabled="!isPublishActivated"><i class="mdi mdi-publish fs-20" @click="publishProduct"></i></el-button>
     </el-tooltip>
    </span>
    <span v-else class="m-10">
      <el-tooltip class="item" effect="dark" :content="$t('products.unPublish')" placement="top">
         <el-button type="text" :disabled="!isCMSModuleActivated || !canManageCMS"><i class="mdi mdi-publish-off fs-20" @click="unpublishProduct"></i></el-button>
     </el-tooltip>
    </span>
  </span>
</template>
<script>
import { mapGetters } from 'vuex';
import InventoryAPI from '@/services/API/inventory'

export default {
  name: 'web-publish-button',
	props: {
    puidPublished: {
      type: Boolean,
      default: false
    },
    puid : {
      type: String,
      default: null,
    },
    lockVersion: {
      type: Number,
      default: null
    }
	},
  data() {
    return {

    };
  },components: {

  },
	methods: {
    unpublishProduct () {
      InventoryAPI.publishPuid(this.puid, { puidPublished: false })
        .then((productInventory) => {
          this.$emit('unpublished', productInventory)
          // this.setSelectedProduct({ selectedProduct: productInventory });
          this.$message.success('Le produit a été dépublié avec succès!');
        }).catch(err => {
          this.$message.error('Erreur lors de la dépublication du produit. Veuillez réessayer plus tard!');
        })
    },
    publishProduct () {
      InventoryAPI.publishPuid(this.puid, { puidPublished: true, published: true, lockVersion: this.lockVersion })
        .then((productInventory) => {
          this.$emit('published', productInventory)
          // this.setSelectedProduct({ selectedProduct: productInventory });
          this.$message.success('Le produit a été publié avec succès!');
        }).catch(err => {
          this.$message.error('Erreur lors de la publication du produit. Veuillez réessayer plus tard!');
        })
    },
	},
	computed: {
    isPublishActivated () {
      return this.puidPublished === false && this.isCMSModuleActivated === true && this.canManageCMS;
    },
    canManageCMS () {
      return this.$can('manage','CMS');
    },
    ...mapGetters('controlData',['isCMSModuleActivated'])
	},
}
</script>
<style lang="scss" scoped>




</style>
